export default __webpack_public_path__ + "static/media/Company Name.bc33760f.svg";